<template>
  <v-container>
    <v-form v-model="valid" autocomplete="on" @submit.prevent="submit">
      <v-layout column wrap>
        <v-text-field
          v-model="login"
          box
          autofocus
          height="50px"
          background-color="#fff"
          type="text"
          name="login"
          label="Логин"
          light
          :rules="loginRules"
          required
        ></v-text-field>
        <v-text-field
          v-model="password"
          box
          height="50px"
          light
          :rules="passwordRules"
          background-color="#fff"
          type="password"
          name="password"
          label="Пароль"
          required
        ></v-text-field>
        <v-btn type="submit" dark :disabled="!valid">Войти</v-btn>
        <span
          v-if="error.message"
          class="error">
          {{ error.message }}
        </span>
      </v-layout>
    </v-form>
  </v-container>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  data: () => ({
    valid: false,
    login: '',
    loginRules: [
      v => !!v || 'Логин обязателен',
    ],
    password: '',
    passwordRules: [
      v => !!v || 'Пароль обязателен',
    ],
  }),
  computed: {
    ...mapState('user', ['error']),
  },
  methods: {
    ...mapMutations(['SET_API_KEY']),
    ...mapActions('user', ['authorize']),

    submit() {
      this.authorize({
        login: this.login,
        password: this.password,
      })
        .then((data) => {
          this.SET_API_KEY(data.apiKey);
          if (data && data.user) this.$router.push({ name: 'home' });
        });
    },
  },
};
</script>
